import React, { createContext, useState, useContext } from 'react';

const BoardContext = createContext();

export const BoardProvider = ({ children }) => {
    const [boardPermalink, setBoardPermalink] = useState('');
    const [boardState, setBoard] = useState({ actionLists: [] });
    const [isEditCard, setEditCard] = useState(null);


    return (
        <BoardContext.Provider
            value={{ boardPermalink, setBoardPermalink, boardState, setBoard, isEditCard, setEditCard }}
        >
            {children}
        </BoardContext.Provider>
    );
};

export const useBoard = () => useContext(BoardContext);
